import createStorageConsumer from 'app/components/utilities/createStorageConsumer';
import { CHAT_SEND_ON_ENTER } from 'app/models/localStorage/constants';
import userAgent, { Platform } from 'app/utils/userAgent';

const DEFAULT_VALUE = userAgent().platform !== Platform.Mobile;

const SendOnEnterConsumer = createStorageConsumer<boolean>(
  'localStorage',
  CHAT_SEND_ON_ENTER,
  {
    serialize: x => x,
    deserialize: x => typeof x === 'boolean' ? x : DEFAULT_VALUE,
  },
);

export default SendOnEnterConsumer;
